import { __assign, __rest } from "tslib";
import b_ from 'b_';
import cn from 'classnames';
import isNil from 'lodash/isNil';
import * as React from 'react';
import InputClear from './InputClear';
import './Input.styl';
var BLOCK_NAME = 'amber-input';
var b = b_.with(BLOCK_NAME);
var getAttrsFromProps = function (_a) {
    var style = _a.style, error = _a.error, theme = _a.theme, className = _a.className, onChange = _a.onChange, onClear = _a.onClear, value = _a.value, clear = _a.clear, iconLeft = _a.iconLeft, iconRight = _a.iconRight, errorText = _a.errorText, needEvent = _a.needEvent, size = _a.size, needPlaceholderWithValue = _a.needPlaceholderWithValue, other = __rest(_a, ["style", "error", "theme", "className", "onChange", "onClear", "value", "clear", "iconLeft", "iconRight", "errorText", "needEvent", "size", "needPlaceholderWithValue"]);
    return other;
};
var inputControl = function (Component) {
    return React.forwardRef(function (props, ref) {
        var error = props.error, disabled = props.disabled, className = props.className, _a = props.theme, theme = _a === void 0 ? 'outline' : _a, style = props.style, iconLeft = props.iconLeft, iconRight = props.iconRight, clear = props.clear, value = props.value, errorText = props.errorText, _b = props.size, size = _b === void 0 ? 'm' : _b, onChange = props.onChange, onClear = props.onClear, needEvent = props.needEvent, placeholder = props.placeholder, needPlaceholderWithValue = props.needPlaceholderWithValue;
        var onChangeHandler = React.useCallback(function (e) {
            if (onChange) {
                onChange(needEvent ? e : e.target.value);
            }
        }, [onChange, needEvent]);
        var onClearHandler = React.useCallback(function () {
            var customEvent = { target: { value: '' } };
            if (onChange) {
                onChange(needEvent ? customEvent : '');
            }
            if (onClear) {
                onClear();
            }
        }, [onChange, onClear, needEvent]);
        var finalClassName = cn(b({
            disabled: disabled,
            theme: theme,
            error: error,
            size: size
        }), className);
        var hasValue = typeof value === 'number' || !!value;
        var attrs = __assign(__assign({}, getAttrsFromProps(props)), { onChange: onChangeHandler, value: isNil(value) ? '' : value, className: b('control', { shifted: hasValue && needPlaceholderWithValue }) });
        var hasInputClear = clear && hasValue;
        return (React.createElement("div", { className: finalClassName, style: style },
            React.createElement("div", { className: b('box') },
                iconLeft && React.createElement("span", { className: b('icon', { left: true }) }, iconLeft),
                iconRight && React.createElement("span", { className: b('icon', { right: true }) }, iconRight),
                hasInputClear && React.createElement(InputClear, { error: !!error, className: b('clear'), onClick: onClearHandler }),
                React.createElement(Component, __assign({ ref: ref }, attrs)),
                hasValue && placeholder && needPlaceholderWithValue && (React.createElement("span", { className: b('absolute-placeholder') }, placeholder)),
                errorText && React.createElement("span", { className: b('error-text') }, errorText))));
    });
};
export default inputControl;
//# sourceMappingURL=inputControl.js.map